module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('a', {
    staticClass: "link",
    attrs: {
      "target": "_blank",
      "rel": "noreferrer",
      "href": "https://www.empreinte.com/"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/img/logo-emp.png",
      "alt": "empreinte_logo"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0746d28c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 155
// module chunks = 1